import React from 'react';
import { BookingCard } from './BookingCard';
import './BookingsGrid.css';

export const BookingsGrid = ({ bookings, emptyMessage = 'No bookings yet. Start exploring events!' }) => {
  console.log("====>bookings", bookings)
  if (!bookings || bookings.length === 0) {
    return (
      <div className="no-bookings-message">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="bookings-grid-new">
      {bookings.map((booking) => (
        <BookingCard key={booking._id} booking={booking} />
      ))}
    </div>
  );
};
